<!-- 考证页面 -->
<template>
  <div class="el-coachExam">
    <el-row class="content_block mb20">
      <div class="Title_Info_box">
        <el-row class="title_head_">
          <el-col :span="11">
            <span class="class_img">
              <el-image class="title_E_img" :src="shiti"></el-image>
            </span>
            <span>从业证考试</span>
          </el-col>
          <el-col :span="13">
            <i class="el-icon-alarm-clock" style="display: none;font-size: 35px;float: left;color: #F83131;"></i>
            <p style="float: left;margin: 0 0 0 10px;color: #F83131;display: none;">倒计时：00:00:{{djs || '00'}}</p>
            <i class="el-icon-close" @click="$router.go(-1)" style="float: right;font-size: 24px;cursor: pointer;margin-top: 5px;"></i>
          </el-col>
        </el-row>
        <el-divider class="m0"></el-divider>
      </div>
      <el-row style="min-height: 320px;overflow: auto;">
        <el-row>
          <!-- 左侧 -->
          <el-row class="left_coachExam">
            <el-row class="coachExam_type danxuan">
              <el-row class="title_coachExam_head" style="color: #2789E2;">
                <span class="class_img">
                  <i class="el-icon-user"></i>
                </span>
                <span style="margin-left: 10px;">考生信息</span>
              </el-row>
              <el-row class="p20">
                <el-image style="width: 80px;height: 80px;border-radius: 50%;float: left;margin-right: 20px;" :src="$getHeadImg()"></el-image>
                <p class="m0 l_h25 pt5">姓名：{{userInfo.name}}</p>
                <p class="m0 l_h25">学号：{{userInfo.code}}</p>
                <p class="m0 l_h25">题数：{{questionListInfo.length}}题</p>
              </el-row>
            </el-row>
            <el-row class="coachExam_type duoxuan">
              <el-row class="title_coachExam_head" style="background-color: white;padding: 0;">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="单选题" name="QuestionType_1" v-if="getDanXuan.length > 0">
                      <el-row class="mb15">
                        <ul>
                          <template v-for='(item,index) in getDanXuan'>
                            <li :class="getClassOn(item,index)" @click="onDanXuan(index)">{{index + 1}}</li>
                          </template>
                        </ul>
                      </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="多选题" name="QuestionType_2" v-if="getDuoXuan.length > 0">
                      <el-row class="mb15">
                        <ul>
                          <template v-for='(item,index) in getDuoXuan'>
                            <li :class="getClassOn(item,index)" @click="onDuoXuan(index)">{{index + 1}}</li>
                          </template>
                        </ul>
                      </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="判断题" name="QuestionType_3" v-if="getPanDuan.length > 0">
                      <el-row class="mb15">
                        <ul>
                          <template v-for='(item,index) in getPanDuan'>
                            <li :class="getClassOn(item,index)" @click="onPanDuan(index)">{{index + 1}}</li>
                          </template>
                        </ul>
                      </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="填空题" name="QuestionType_4" v-if="getTianKong.length > 0">
                      <el-row class="mb15">
                        <ul>
                          <template v-for='(item,index) in getTianKong'>
                            <li :class="getClassOn(item,index)" @click="onTianKong(index)">{{index + 1}}</li>
                          </template>
                        </ul>
                      </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="分析题" name="QuestionType_5" v-if="getFenXi.length > 0">
                      <el-row class="mb15">
                        <ul>
                          <template v-for='(item,index) in getFenXi'>
                            <li :class="getClassOn(item,index)" @click="onFenXi(index)">{{index + 1}}</li>
                          </template>
                        </ul>
                      </el-row>
                    </el-tab-pane>
                  </el-tabs>
                  <el-row style="margin-bottom: 20px;">
                    <el-button class="z_d but_class" style="margin-left: 15px;">在答</el-button>
                    <el-button class="w_d but_class">未答</el-button>
                    <el-button class="z_q but_class">正确</el-button>
                    <el-button class="d_c but_class">答错</el-button>
                    <!-- <el-button class="c_z but_class">重做</el-button> -->
                  </el-row>
              </el-row>
            </el-row>
          </el-row>

          <el-row class="right_coachExam">
            <!-- 单选题 -->
            <el-row class="coachExam_type" style="margin:0;">
              <el-row class="title_coachExam_head" style="color: #5464FF;">
                <span class="class_img">
                  <el-image class="title_coachExam_img" :src="danxuan"></el-image>
                </span>
                <span style="margin-left: 10px;">
                  {{$retQuestionType(onInfo.questionType)}}
                  （ {{onInfo.questionScore || '-'}} 分 ）
                </span>
                <!-- <el-button style="float: right;" size="small" :loading="submitShow" icon="el-icon-position" type="success" @click="submitPaper()">
                  交卷
                </el-button> -->
              </el-row>
              <el-row class="p20">
                <el-row :class="onInfo.generalQuestionLogAnswer == onInfo.questionAnswer?'answerClass':'wrongClass'" :style="'min-height:'+ (examType==1?'339px':'415px')">
                  <el-col :span="21">
                    <el-row style="float: left;width: 30px;">
                      {{typeNum[activeName] + 1}}、
                    </el-row>
                    <el-row style="float: left;width: calc(100% - 30px);line-height: 20px;margin-bottom: 10px;">
                      <!-- <el-row class="questionStemClass" v-html="onInfo.questionStem"></el-row> -->
                      <previewIndex :key="onInfo.generalQuestionLogId" :editorId="onInfo.generalQuestionLogId+'_stem'" styleInfo="border:none;padding:0;" v-if="!$isEmpty(onInfo.questionStem)" :modelValue="onInfo.questionStem"></previewIndex>
                    </el-row>
                    <ul style="width: 100%;margin-left: 30px;">
                      <template v-if="onInfo.questionType == 1">
                        <el-radio-group disabled v-model="radio[onInfo.generalResourcesQuestionSnapshotId]">
                          <li v-if="!$isEmpty(onInfo.questionOptionA)">
                            <el-radio label="A">
                              <el-row class="optionInfo">A、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionA)"></el-row>
                            </el-radio>
                          </li>
                          <li v-if="!$isEmpty(onInfo.questionOptionB)">
                            <el-radio label="B">
                              <el-row class="optionInfo">B、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionB)"></el-row>
                            </el-radio>
                          </li>
                          <li v-if="!$isEmpty(onInfo.questionOptionC)">
                            <el-radio label="C">
                              <el-row class="optionInfo">C、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionC)"></el-row>
                            </el-radio>
                          </li>
                          <li v-if="!$isEmpty(onInfo.questionOptionD)">
                            <el-radio label="D">
                              <el-row class="optionInfo">D、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionD)"></el-row>
                            </el-radio>
                          </li>
                          <li v-if="!$isEmpty(onInfo.questionOptionE)">
                            <el-radio label="E">
                              <el-row class="optionInfo">E、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionE)"></el-row>
                            </el-radio>
                          </li>
                        </el-radio-group>
                      </template>
                      <template v-if="onInfo.questionType == 2">
                        <el-checkbox-group disabled v-model="checkbox[onInfo.generalResourcesQuestionSnapshotId]">
                          <li v-if="!$isEmpty(onInfo.questionOptionA)">
                            <el-checkbox label="A">
                              <el-row class="optionInfo">A、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionA)"></el-row>
                            </el-checkbox>
                          </li>
                          <li v-if="!$isEmpty(onInfo.questionOptionB)">
                            <el-checkbox label="B">
                              <el-row class="optionInfo">B、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionB)"></el-row>
                            </el-checkbox>
                          </li>
                          <li v-if="!$isEmpty(onInfo.questionOptionC)">
                            <el-checkbox label="C">
                              <el-row class="optionInfo">C、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionC)"></el-row>
                            </el-checkbox>
                          </li>
                          <li v-if="!$isEmpty(onInfo.questionOptionD)">
                            <el-checkbox label="D">
                              <el-row class="optionInfo">D、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionD)"></el-row>
                            </el-checkbox>
                          </li>
                          <li v-if="!$isEmpty(onInfo.questionOptionE)">
                            <el-checkbox label="E">
                              <el-row class="optionInfo">E、</el-row>
                              <el-row class="xuanxiang" v-html="$imgHtml(onInfo.questionOptionE)"></el-row>
                            </el-checkbox>
                          </li>
                        </el-checkbox-group>
                      </template>
                      <template v-if="onInfo.questionType == 3">
                        <el-radio-group disabled v-model="judgeQuestion[onInfo.generalResourcesQuestionSnapshotId]">
                          <li>
                            <el-radio label="对">
                              <el-row class="xuanxiang">对</el-row>
                            </el-radio>
                          </li>
                          <li>
                            <el-radio label="错">
                                <el-row class="xuanxiang">错</el-row>
                            </el-radio>
                          </li>
                        </el-radio-group>
                      </template>
                    </ul>
                    <template v-if="onInfo.questionType == 4">
                      <template v-for="i in Number(onInfo.questionOptionA)">
                        <el-input
                          type="textarea"
                          @change="seeQuestion(onInfo,i)"
                          :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"
                          :style="Number(onInfo.questionOptionA) > 1 && i != Number(onInfo.questionOptionA)?'margin-bottom: 10px;':''"
                          v-model="completion[onInfo.generalQuestionLogId][i]">
                        </el-input>
                      </template>
                    </template>
                    <template v-if="onInfo.questionType == 5">
                      <el-row class="questionStemClass" style="margin-bottom: 10px;">
                        <previewIndex :editorId="onInfo.generalQuestionLogId" v-if="!$isEmpty(onInfo.questionOptionB)" styleInfo="border:none;padding:0px 20px;" :modelValue="onInfo.questionOptionB"></previewIndex>
                      </el-row>
                      <template v-for="i in Number(onInfo.questionOptionA)">
                        <el-input
                          type="textarea"
                          @change="seeQuestion(onInfo,i)"
                          :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="请输入内容"
                          :style="Number(onInfo.questionOptionA) > 1 && i != Number(onInfo.questionOptionA)?'margin-bottom: 10px;':''"
                          v-model="analyticQuestion[onInfo.generalQuestionLogId][i]">
                        </el-input>
                      </template>
                    </template>

                      <el-row style="line-height: 30px;">
                        <el-row v-if="onInfo.questionType != 4 && onInfo.questionType != 5" style="display: flex;align-items: center;">
                          <i class="el-icon-circle-check" style="color: #5464FF;font-size: 40px;" v-if="onInfo.generalQuestionLogAnswer == onInfo.questionAnswer"></i>
                          <i class="el-icon-circle-close" style="color: red;font-size: 40px;" v-else ></i>
                          <span style="margin-left: 10px;">正确答案：{{onInfo.questionAnswer}}</span>
                          <span style="margin-left: 10px;">我的答案：{{onInfo.generalQuestionLogAnswer || ''}}</span>
                        </el-row>
                        <el-row v-if="onInfo.questionType == 4 || onInfo.questionType == 5">
                          <el-col :span="2">
                            <i class="el-icon-circle-check" style="color: #5464FF;font-size: 40px;" v-if="onInfo.generalQuestionLogAnswer == onInfo.questionAnswer"></i>
                            <i class="el-icon-circle-close" style="color: red;font-size: 40px;" v-else ></i>
                          </el-col>
                          <el-col :span="10">
                            <el-row style="width: 100%;" v-for="(ite,inde) in JSON.parse(onInfo.questionAnswer)" :key="inde+onInfo.generalQuestionLogId">
                              <p class="mt5 mb5"><span style="color: rgb(84, 100, 255);">{{$chineseNum(inde - 1,1)}}:</span>{{ite}}</p>
                            </el-row>
                          </el-col>
                        </el-row>
                        <p>解析：{{onInfo.questionAnalysis}}</p>
                      </el-row>
                  </el-col>
                  <el-col :span="3" class="t_r">
                    <!-- <el-button size="small" @click="collection(onInfo)" plain icon="el-icon-star-off">
                      {{onInfo.isTuck ? '已': ''}}收藏
                    </el-button> -->
                  </el-col>
                </el-row>
                <el-row>
                  <!-- <el-button type="success" :loading="submitShow" @click="seeQuestion(onInfo)" icon="el-icon-position" :disabled="!$isEmpty(onInfo.generalQuestionLogAnswer)">确定答案</el-button> -->
                  <!--  :disabled="typeNum['QuestionType_'+onInfo.questionType] == 0"  -->
                  <el-button type="primary" icon="el-icon-arrow-left" @click="previous">上一题</el-button>
                  <el-button type="primary" @click="next" >下一题<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-row>
              </el-row>
            </el-row>
          </el-row>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import previewIndex from "@/components/editorMd/previewIndex";	//富文本editorMd
export default {
  name: "CoachExam",
  components: {
  	TitleInfo,
    previewIndex
  },
  data() {
    return {
      submitShow:false,
      userInfo:this.$ls.get(this.$getKeyInfo("userInfo")) || {},
      examType:this.$route.query.type, //1:考试 2:查看成绩
      generalQuestionSettingId:this.$route.query.generalQuestionSettingId,
      shiti:require("../../images/course/shiti@2x.png"),
      danxuan:require("../../images/course/danxuan@2x.png"),
      danxuan_b:require("../../images/course/danxuan-b@2x.png"),
      duoxuan:require("../../images/course/duoxuan@2x.png"),
      duoxuan_b:require("../../images/course/duoxuan-b@2x.png"),
      panduan:require("../../images/course/panduan@2x.png"),
      panduan_b:require("../../images/course/panduan-b@2x.png"),
      zhishidian:require("../../images/course/zhishidian@2x.png"),
      cont:require("../../images/course/cont@2x.png"),
      zhisdian:require("../../images/course/zhisdian@2x.png"),
      zql:require("../../images/course/zql@2x.png"),
      zongdefen:require("../../images/course/zongdefen@2x.png"),
      zongdefen:require("../../images/course/zongdefen@2x.png"),
      tableData:[],
      onButType:0, //0:单选 1：多选 2：判断
      radio:{}, //单选题答案
      checkbox:{},//多选题答案
      judgeQuestion:{},//判断题
      completion:{}, //填空题
      analyticQuestion:{}, //分析题
      activeName: 'QuestionType_1', //左侧题型
      getDanXuan:[],
      getDuoXuan:[],
      getPanDuan:[],
      getTianKong:[],
      getFenXi:[],
      onInfo:{}, //当前所做题目
      djs:0,
      time:0,
      typeNum:{ //题型做到了哪个位置
        "QuestionType_1":0,
        "QuestionType_2":0,
        "QuestionType_3":0,
        "QuestionType_4":0,
        "QuestionType_5":0,
      },
      questionListInfo:[], //所有题目信息
      courseInfoName:this.$route.query.courseInfoName,
      timeIn:null
    };
  },
  created() {
    let this_ = this;
    this.getDuoXuan.forEach(function(item){
      this_.checkbox[item.id] = [];
    });
    this.checkbox = Object.assign({}, this.checkbox);
    let setInt = setInterval(function() {
      if(this_.djs <= 0){
        clearInterval(setInt)
      }else{
        this_.djs --;
      }
    }, 1000);
  },//this.addSystem
  mounted() {
    if(!this.$isEmpty(this.generalQuestionSettingId)){
      this.getInfo();
      this.getDateTime();
      this.addSystem();
    }
  },
  computed:{
    getClassOn(){
      return function (it,index) {
        if(it.questionType == 1){
          if(this.typeNum['QuestionType_1'] == index){
            return "z_d";
          }else if(!this.$isEmpty(it.generalQuestionLogAnswer) && it.questionAnswer == it.generalQuestionLogAnswer){
            return "z_q"
          }else if(it.questionAnswer != it.generalQuestionLogAnswer){
            return "d_c";
          }
        }else if(it.questionType == 2){
          if(this.typeNum['QuestionType_2'] == index){
            return "z_d";
          }else if(!this.$isEmpty(it.generalQuestionLogAnswer) && it.questionAnswer == it.generalQuestionLogAnswer){
            return "z_q"
          }else if(it.questionAnswer != it.generalQuestionLogAnswer){
            return "d_c";
          }
        }else if(it.questionType == 3){
          if(this.typeNum['QuestionType_3'] == index){
            return "z_d";
          }else if(!this.$isEmpty(it.generalQuestionLogAnswer) && it.questionAnswer == it.generalQuestionLogAnswer){
            return "z_q"
          }else if(it.questionAnswer != it.generalQuestionLogAnswer){
            return "d_c";
          }
        }else if(it.questionType == 4){
          if(this.typeNum['QuestionType_4'] == index){
            return "z_d";
          }else if(!this.$isEmpty(it.generalQuestionLogAnswer) && it.questionAnswer == it.generalQuestionLogAnswer){
            return "z_q"
          }else if(it.questionAnswer != it.generalQuestionLogAnswer){
            return "d_c";
          }
        }else if(it.questionType == 5){
          if(this.typeNum['QuestionType_5'] == index){
            return "z_d";
          }else if(!this.$isEmpty(it.generalQuestionLogAnswer) && it.questionAnswer == it.generalQuestionLogAnswer){
            return "z_q"
          }else if(it.questionAnswer != it.generalQuestionLogAnswer){
            return "d_c";
          }
        }else{
          return "";
        }
      }
    }
  },
  methods: {
    handleClick(tab){
      if(tab.name == "QuestionType_1"){
        this.onDanXuan(this.typeNum[tab.name]);
      }else if(tab.name == "QuestionType_2"){
        this.onDuoXuan(this.typeNum[tab.name]);
      }else if(tab.name == "QuestionType_3"){
        this.onPanDuan(this.typeNum[tab.name]);
      }else if(tab.name == "QuestionType_4"){
        this.onTianKong(this.typeNum[tab.name]);
      }else if(tab.name == "QuestionType_5"){
        this.onFenXi(this.typeNum[tab.name]);
      }
    },
    getDateTime(){
      this.$get("/api/base/dateTime.do").then((ret) =>{
        if(ret.code == 0){
          this.time = ret.data.timestamp; //时间戳：timestamp 年月日时分秒：dateTime
          this.setIntervalName = setInterval(()=>{
            this.time = Number(this.time) + 1000;
          },1000)
        }
      });
    },
    getInfo(){ //获取通知公告列表
      const loading = this.$loading({
        lock: true,
        text: '加载题目中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$post("/api/generalResourcesQuestionSnapshot/getScoreInfo.do",{
        questionSettingId:this.generalQuestionSettingId,
        questionLogAddType:"FINALLY_SUBMIT"
      }).then((ret) =>{
        loading.close();
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data) && ret.data.questionLogList.length > 0){
            this.questionListInfo = ret.data.questionLogList;
            ret.data.questionLogList.forEach((item,i)=>{ //处理题目数据，按照自己的需求根据不同题目类型格式化
              if(item.questionType == 1){
                this.getDanXuan.push(item);
                this.radio[item.generalResourcesQuestionSnapshotId] = item.questionAnswer;
              }else if(item.questionType == 2){
                this.getDuoXuan.push(item);
                this.checkbox[item.generalResourcesQuestionSnapshotId] = !this.$isEmpty(item.questionAnswer)?item.questionAnswer.split(","):[];
              }else if(item.questionType == 3){
                this.getPanDuan.push(item);
                this.judgeQuestion[item.generalResourcesQuestionSnapshotId] = item.questionAnswer;
              }else if(item.questionType == 4){
                this.getTianKong.push(item);
                if(!this.$isEmpty(item.generalQuestionLogAnswer)){
                  let generalQuestionLogAnswer = JSON.parse(item.generalQuestionLogAnswer);
                  this.completion[item.generalQuestionLogId] = {};
                  for(let obj in generalQuestionLogAnswer){
                   this.completion[item.generalQuestionLogId][obj] = generalQuestionLogAnswer[obj];
                  }
                }else{
                  this.completion[item.generalQuestionLogId] = {};
                }
              }else if(item.questionType == 5){
                this.getFenXi.push(item);
                if(!this.$isEmpty(item.generalQuestionLogAnswer)){
                  let generalQuestionLogAnswer = JSON.parse(item.generalQuestionLogAnswer);
                  this.analyticQuestion[item.generalQuestionLogId] = {};
                  for(let obj in generalQuestionLogAnswer){
                   this.analyticQuestion[item.generalQuestionLogId][obj] = generalQuestionLogAnswer[obj];
                  }
                }else{
                  this.analyticQuestion[item.generalQuestionLogId] = {};
                }
              }
            });
            this.radio = Object.assign({},this.radio);
            this.checkbox = Object.assign({},this.checkbox);
            this.judgeQuestion = Object.assign({},this.judgeQuestion);
            this.completion = Object.assign({},this.completion);
            this.analyticQuestion = Object.assign({},this.analyticQuestion);
            if(this.getDanXuan.length > 0){
              this.onInfo = this.getDanXuan[0];
              this.activeName = "QuestionType_1";
            }else if(this.getDuoXuan.length > 0){
              this.onInfo = this.getDuoXuan[0];
              this.activeName = "QuestionType_2";
            }else if(this.getPanDuan.length > 0){
              this.onInfo = this.getPanDuan[0];
              this.activeName = "QuestionType_3";
            }else if(this.getTianKong.length > 0){
              this.onInfo = this.getTianKong[0];
              this.activeName = "QuestionType_4";
            }else if(this.getFenXi.length > 0){
              this.onInfo = this.getFenXi[0];
              this.activeName = "QuestionType_5";
            }
          }else{
            this.$message({message: "没有查询到题目信息",type: 'error'});
            setTimeout(()=>{
              this.$router.go(-1);
            },1000);
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      }).catch(() => {
        loading.close();
        this.$router.go(-1);
      });
    },
    butType(index){ //选择题型
      this.onButType = index;
    },
    onDanXuan(index){
      this.onInfo = this.getDanXuan[index];
      this.typeNum['QuestionType_1'] = index;
    },
    onDuoXuan(index){
      this.onInfo = this.getDuoXuan[index];
      this.typeNum['QuestionType_2'] = index;
    },
    onPanDuan(index){
      this.onInfo = this.getPanDuan[index];
      this.typeNum['QuestionType_3'] = index;
    },
    onTianKong(index){
      this.onInfo = this.getTianKong[index];
      this.typeNum['QuestionType_4'] = index;
    },
    onFenXi(index){
      this.onInfo = this.getFenXi[index];
      this.typeNum['QuestionType_5'] = index;
    },
    collection(item){ //收藏或者取消收藏
      let param = {
        questionSettingId:item.generalQuestionSettingId,
        questionSnapIds:item.generalResourcesQuestionSnapshotId,
        isTuck:item.isTuck?false:true
      }
      this.$post("/api/generalQuestionLog/tuck.do",param).then((ret) =>{
        if(ret.code == 0){
          this.$message.success(item.isTuck?'取消成功!':'收藏成功!');
          item.isTuck = item.isTuck?false:true;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    seeQuestion(item,key){ //做题，题目变动时调用
      let param = {questionLogMap:{}};
      if(item.questionType == 1){
        param.questionLogMap[item.generalResourcesQuestionSnapshotId] = this.radio[item.generalResourcesQuestionSnapshotId];
      }else if(item.questionType == 2){
        param.questionLogMap[item.generalResourcesQuestionSnapshotId] = this.checkbox[item.generalResourcesQuestionSnapshotId].join(",");
      }else if(item.questionType == 3){
        param.questionLogMap[item.generalResourcesQuestionSnapshotId] = this.judgeQuestion[item.generalResourcesQuestionSnapshotId];
      }else if(item.questionType == 4){ //填空题
        if(this.$isEmpty(this.completion[item.generalQuestionLogId][key])){
          delete this.completion[item.generalQuestionLogId][key]
        }
        if(Object.keys(this.completion[item.generalQuestionLogId]).length > 0){
          param.questionLogMap[item.generalQuestionLogId] = JSON.stringify(this.completion[item.generalQuestionLogId]);
        }else{
          param.questionLogMap[item.generalQuestionLogId] = "";
        }
      }else if(item.questionType == 5){
        if(this.$isEmpty(this.analyticQuestion[item.generalQuestionLogId][key])){
          delete this.analyticQuestion[item.generalQuestionLogId][key]
        }
        if(Object.keys(this.analyticQuestion[item.generalQuestionLogId]).length > 0){
          param.questionLogMap[item.generalQuestionLogId] = JSON.stringify(this.analyticQuestion[item.generalQuestionLogId]);
        }else{
          param.questionLogMap[item.generalQuestionLogId] = "";
        }
      }
      if(!this.$isEmpty(key)){
        return;
      }
      if(this.$isEmpty(param.questionLogMap[item.generalResourcesQuestionSnapshotId])){
        this.$message.warning("请先选择您的答案！");
        return;
      }
      param.questionLogAddType = "PRE_SUBMIT";
      this.submitInfo(param,item);
    },
    submitPaper(){ //提交试卷
      this.$confirm('是否确定提交试卷？提交后无法修改！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {questionLogMap:{}};
        for(let key in this.radio){
          if(!this.$isEmpty(this.radio[key])){
            param.questionLogMap[key] = this.radio[key];
          }else{
            param.questionLogMap[key] = "";
          }
        }
        for(let key in this.checkbox){
          if(!this.$isEmpty(this.checkbox[key])){
            param.questionLogMap[key] = this.checkbox[key].join(",");
          }else{
            param.questionLogMap[key] = "";
          }
        }
        for(let key in this.judgeQuestion){
          if(!this.$isEmpty(this.judgeQuestion[key])){
            param.questionLogMap[key] = this.judgeQuestion[key];
          }else{
            param.questionLogMap[key] = "";
          }
        }
        for(let key in this.completion){
          if(!this.$isEmpty(this.completion[key])){
            param.questionLogMap[key] = this.completion[key];
          }else{
            param.questionLogMap[key] = "";
          }
        }
        for(let key in this.analyticQuestion){
          if(!this.$isEmpty(this.analyticQuestion[key])){
            param.questionLogMap[key] = this.analyticQuestion[key];
          }else{
            param.questionLogMap[key] = "";
          }
        }
        param.questionLogAddType = "FINALLY_SUBMIT";
        if(Object.keys(param.questionLogMap).length != this.questionListInfo.length){
          this.$confirm('题目未答完！是否确定交卷？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submitInfo(param);
          }).catch(() => {
            this.$message({type: 'info',message: '已取消'});
          });
        }else{
          this.submitInfo(param);
        }
      }).catch(() => {
        this.$message({type: 'info',message: '已取消'});
      });
    },
    submitInfo(param,item){ //提交数据（答案或者交卷数据）
      this.submitShow = true;
      param.questionSettingId = this.generalQuestionSettingId;
      param.addTime = this.$timeFormat(this.time,'yyyy-MM-dd HH:mm:ss');
      this.$postJSON("/api/generalQuestionLog/addQuestionLog.do",param).then((ret) =>{
        this.submitShow = false;
        if(ret.code == 0){
          if(param.questionLogAddType == "FINALLY_SUBMIT"){ //FINALLY_SUBMIT：交卷  PRE_SUBMIT：预提交
            this.$message.success('交卷成功!');
            setTimeout(()=>{
              this.$router.go(-1);
            },500);
          }else{
            this.questionLogAnswerLock(item);
          }
        }else{
          if(param.questionLogAddType == "PRE_SUBMIT"){
            if(item.questionType == 1){
              this.radio[item.generalResourcesQuestionSnapshotId] = "";
            }else if(item.questionType == 2){
              this.checkbox[item.generalResourcesQuestionSnapshotId] = [];
            }else if(item.questionType == 3){
              this.judgeQuestion[item.generalResourcesQuestionSnapshotId]  = "";
            }
          }
          this.$message({message: ret.msg,type: 'error'});
        }
      }).catch(() => {
        this.submitShow = false;
      });
    },
    questionLogAnswerLock(item){ //选中选项后，通过这个获取题目答案和分析。接口会锁定这道题。
      let param = {
        questionSettingId:item.generalQuestionSettingId,
        questionSnapIds:item.generalResourcesQuestionSnapshotId,
      }
      this.$post("/api/generalQuestionLog/questionLogAnswerLock.do",param).then((ret) =>{
        if(ret.code == 0){
         item.generalQuestionLogAnswer = ret.data[0].generalQuestionLogAnswer;
         item.questionAnswer = ret.data[0].questionAnswer;
         item.questionAnalysis = ret.data[0].questionAnalysis;
         this.getDanXuan = Object.assign([],this.getDanXuan);
         this.getDuoXuan = Object.assign([],this.getDuoXuan);
         this.getPanDuan = Object.assign([],this.getPanDuan);
         this.getTianKong = Object.assign([],this.getTianKong);
         this.getFenXi = Object.assign([],this.getFenXi);
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    previous(){ //上一题
      if(this.activeName == 'QuestionType_1'){ //单选题
        if(this.typeNum['QuestionType_1'] > 0){
          this.typeNum['QuestionType_1'] = this.typeNum['QuestionType_1'] - 1;
          this.onInfo = this.getDanXuan[this.typeNum['QuestionType_1']];
        }else{
           this.$message.warning('该题型已是第一题!');
        }
      }else if(this.activeName == 'QuestionType_2'){ //多选题
        if(this.typeNum['QuestionType_2'] > 0){
          this.typeNum['QuestionType_2'] = this.typeNum['QuestionType_2'] - 1;
          this.onInfo = this.getDuoXuan[this.typeNum['QuestionType_2']];
        }else{
           this.$message.warning('该题型已是第一题!');
        }
      }else if(this.activeName == 'QuestionType_3'){ //判选题
        if(this.typeNum['QuestionType_3'] > 0){
          this.typeNum['QuestionType_3'] = this.typeNum['QuestionType_3'] - 1;
          this.onInfo = this.getPanDuan[this.typeNum['QuestionType_3']];
        }else{
           this.$message.warning('该题型已是第一题!');
        }
      }else if(this.activeName == 'QuestionType_4'){ //填空题
        if(this.typeNum['QuestionType_4'] > 0){
          this.typeNum['QuestionType_4'] = this.typeNum['QuestionType_4'] - 1;
          this.onInfo = this.getTianKong[this.typeNum['QuestionType_4']];
        }else{
           this.$message.warning('该题型已是第一题!');
        }
      }else if(this.activeName == 'QuestionType_5'){ //分析题
        if(this.typeNum['QuestionType_5'] > 0){
          this.typeNum['QuestionType_5'] = this.typeNum['QuestionType_5'] - 1;
          this.onInfo = this.getFenXi[this.typeNum['QuestionType_5']];
        }else{
           this.$message.warning('该题型已是第一题!');
        }
      }
    },
    next(){ //下一题
      if(this.activeName == 'QuestionType_1'){ //单选题
        if(this.getDanXuan.length - 1 > this.typeNum['QuestionType_1']){
          this.typeNum['QuestionType_1'] = this.typeNum['QuestionType_1'] + 1;
          this.onInfo = this.getDanXuan[this.typeNum['QuestionType_1']];
        }else{
           this.$message.warning('该题型已是最后一题!');
        }
      }else if(this.activeName == 'QuestionType_2'){ //多选题
        if(this.getDuoXuan.length - 1 > this.typeNum['QuestionType_2']){
          this.typeNum['QuestionType_2'] = this.typeNum['QuestionType_2'] + 1;
          this.onInfo = this.getDuoXuan[this.typeNum['QuestionType_2']];
        }else{
           this.$message.warning('该题型已是最后一题!');
        }
      }else if(this.activeName == 'QuestionType_3'){ //判选题
        if(this.getPanDuan.length - 1 > this.typeNum['QuestionType_3']){
          this.typeNum['QuestionType_3'] = this.typeNum['QuestionType_3'] + 1;
          this.onInfo = this.getPanDuan[this.typeNum['QuestionType_3']];
        }else{
           this.$message.warning('该题型已是最后一题!');
        }
      }else if(this.activeName == 'QuestionType_4'){ //填空题
        if(this.getTianKong.length - 1 > this.typeNum['QuestionType_4']){
          this.typeNum['QuestionType_4'] = this.typeNum['QuestionType_4'] + 1;
          this.onInfo = this.getTianKong[this.typeNum['QuestionType_4']];
        }else{
           this.$message.warning('该题型已是最后一题!');
        }
      }else if(this.activeName == 'QuestionType_5'){ //分析题
        if(this.getFenXi.length - 1 > this.typeNum['QuestionType_5']){
          this.typeNum['QuestionType_5'] = this.typeNum['QuestionType_5'] + 1;
          this.onInfo = this.getFenXi[this.typeNum['QuestionType_5']];
        }else{
           this.$message.warning('该题型已是最后一题!');
        }
      }
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"考证辅导",//一级名称
          secondName:this.courseInfoName,//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-coachExam{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
    .title_head_{
      line-height: 40px;
      padding: 10px 20px;
    }
    .title_E_img{
      width: 40px;float: left;margin-right: 10px;
    }
    .coachExam_type{
      border: 1px solid #D3D3D3;
      margin: 20px 20px 0;
      .title_coachExam_head{
        background-color: #EFF2F7;
        padding: 5px 10px;
        line-height: 30px;
      }
      .title_coachExam_img{
        width: 30px;
        float: left;
      }
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
        width: 421px;
        min-height: 230px;
        // max-height: 230px;
        // overflow-y: auto;
      }
    }
    .left_coachExam,.right_coachExam{
      height: calc(100vh - 200px);overflow-y: auto;float: left;
    }
    .left_coachExam{
      width: 485px;border-right: 1px solid #DCDFE6;
      li{
        float: left;
        width: 34px;
        height: 34px;
        line-height: 34px;
        border: 1px solid #D3D3D3;
        text-align: center;
        margin: 15px 0 0 15px;
        cursor: pointer;
        border-radius: 2px;
      }
    }
    .right_coachExam{
      width: calc(100vw - 635px);
      float: left;
      overflow: auto;
      padding: 20px;

      ul{
        padding: 10px 0;
      }
      li{
        line-height: 20px;
      }
      .el-radio__input.is-disabled+span.el-radio__label,.el-checkbox__input.is-disabled+span.el-checkbox__label{
        color: #424344;
      }
    }
    .but_coachExam_img{
      width: 20px;
      height: 20px;
      float: left;
      margin-right:5px;
    }
    .el-button--small{
      padding: 5px 15px;
      line-height: 20px;
    }
    .danxuan_but{
      color: #5464FF;
      border: 1px solid;
    }
    .duoxuan_but{
      color: #00BDCE;
      border: 1px solid;
    }
    .panduan_but{
      color: #2789E2;
      border: 1px solid;
    }
    .el-radio__input,.el-radio__label,.el-checkbox__input,.el-checkbox__label{
      float: left;
    }
    .points_class_dialog{
      ul{
        list-style-type:none;
        margin: 0;
        padding: 10px;
        height: 320px;
        overflow: auto;
      }
      li{
        line-height: 30px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
         /*! autoprefixer: off */
         -webkit-box-orient: vertical;
         /* autoprefixer: on */
         cursor: pointer;
      }
      .on{
        color: #2789E2;
      }
      .el-dialog__header{
        border-bottom: 1px solid #D3D3D3;
      }
      .rigth_box{
        p{
          margin: 0 !important;
        }
      }
    }
    .el-tabs__header{
      background-color:#eff2f7;
    }
    .el-tabs__nav-wrap::after{
      background-color:#eff2f7;
    }
    .el-tabs--top .el-tabs__item.is-top:nth-child(2){
      padding-left:20px;
    }
    .fsxx{
      float: left;
      margin-right: 20px;
    }
    .but_class{
      padding: 0;margin: 0;text-align: center;
      width: calc(25% - 20px);
      padding: 10px 0;
      margin-left: 10px;
    }
    .z_q{
      background-color: #409eff !important;color: white;border-color: #409eff !important;
    }
    .z_d{
      background-color: orange !important;color: white;border-color: orange !important;
    }
    .w_d{
      border-color: #D3D3D3 !important;
    }
    .d_c{
      background-color: #FF6554 !important;color: white;border-color: #FF6554 !important;
    }
    .c_z{
      background-color: #00BDCE !important;color: white;border-color: #00BDCE !important;
    }

    //宽度小于等于
    @media screen and (max-width:1536px){
      .left_coachExam,.right_coachExam{
        height: calc(100vh - 170px);overflow-y: auto;float: left;
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/certificate/CoachExamDetails.vue